"use client";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

const BoutonsSlides = ({ imgList, from, to }) => {
  const [index, setIndex] = useState([...Array(to + 1).keys()].map((i) => i));
  const minus = () => {
    setIndex([
      ...index.map((el) => {
        return el == 0 ? to : el - 1;
      }),
    ]);
  };
  const plus = () => {
    setIndex([
      ...index.map((el) => {
        return el == to ? 0 : el + 1;
      }),
    ]);
  };
  return (
    <div>
      <h1 className="font-agency text-center text-[22px] md:text-[65px] font-bold">
        Boutons èlectriques
        <br />
        pour les marque des voitures 
        <span className="text-[#CC0001]"> les plus demandées</span>
      </h1>
      {/* Slider in Larger device */}
      <div className="hidden lg:flex justify-between items-center ">
        <Image
          src={"/icons/BoutonsSlideFleshLeft.png"}
          width={30}
          height={18}
          className="object-contain w-[30px] h-[18px] cursor-pointer"
          onClick={minus}
          alt="Flesh-Left-Icon"
        />
        <div className="flex items-center justify-between w-full">
          <Link
            href={`/product/${imgList[index[0]]?.categories[0]}/${
              imgList[index[0]]?._id
            }`}
          >
            <img
              src={imgList[index[0]]?.image}
              width={3000}
              height={3000}
              alt="Product-Photo"
              className="object-contain w-[150px] h-[133px] opacity-25"
            />
          </Link>
          <Link
            href={`/product/${imgList[index[1]]?.categories[0]}/${
              imgList[index[1]]?._id
            }`}
          >
            <img
              src={imgList[index[1]]?.image}
              width={3000}
              height={3000}
              alt="Product-Photo"
              className="object-contain w-[150px] h-[133px] opacity-25"
            />
          </Link>
          <Link
            href={`/product/${imgList[index[2]]?.categories[0]}/${
              imgList[index[2]]?._id
            }`}
          >
            <img
              src={imgList[index[2]]?.image}
              width={3000}
              height={3000}
              alt="Product-Photo"
              className="object-contain w-[150px] h-[133px]"
            />
          </Link>
          <Link
            className="w-[280px]"
            href={`/product/${imgList[index[3]]?.categories[0]}/${
              imgList[index[3]]?._id
            }`}
          >
            <img
              src={imgList[index[3]]?.image}
              width={3000}
              height={3000}
              alt="Product-Photo"
              className="object-cover w-[280px] h-[267px]"
            />
            <h2 className="md:text-[40px] w-fit mx-auto text-center mb-1">
              {imgList[index[3]]?.name}
            </h2>
          </Link>
          <Link
            href={`/product/${imgList[index[4]]?.categories[0]}/${
              imgList[index[4]]?._id
            }`}
          >
            <img
              src={imgList[index[4]]?.image}
              width={3000}
              height={3000}
              alt="Product-Photo"
              className="object-contain w-[150px] h-[133px]"
            />
          </Link>
          <Link
            href={`/product/${imgList[index[5]]?.categories[0]}/${
              imgList[index[5]]?._id
            }`}
          >
            <img
              src={imgList[index[5]]?.image}
              width={3000}
              height={3000}
              alt="Product-Photo"
              className="object-contain w-[150px] h-[133px] opacity-25"
            />
          </Link>
          <Link
            href={`/product/${imgList[index[6]]?.categories[0]}/${
              imgList[index[6]]?._id
            }`}
          >
            <img
              src={imgList[index[6]]?.image}
              width={3000}
              height={3000}
              alt="Product-Photo"
              className="object-contain w-[150px] h-[133px] opacity-25"
            />
          </Link>
        </div>
        <Image
          src={"/icons/BoutonsSlideFleshRight.png"}
          width={30}
          height={18}
          alt="Flesh-Right-Icon"
          className="object-contain w-[30px] h-[18px] cursor-pointer"
          onClick={plus}
        />
      </div>
      {/* Slider in small device */}
      <div className="flex justify-between items-center lg:hidden">
        <Image
          src={"/icons/BoutonsSlideFleshLeft.png"}
          width={30}
          height={18}
          alt="Flesh-Left-Icon"
          className="object-contain w-[30px] h-[18px] cursor-pointer"
          onClick={minus}
        />
        <div className="flex items-center justify-between w-full">
          <Link
            href={`/product/${imgList[index[3]]?.categories[0]}/${
              imgList[index[3]]?._id
            }`}
            className="w-full flex flex-col justify-center items-center"
          >
            <img
              src={imgList[index[3]]?.image}
              width={244}
              height={267}
              alt="Product-Photo"
              className="object-cover w-[280px] h-[267px]"
            />
            <h2 className="w-[50%] text-[20px] mx-auto text-center mb-1">
              {imgList[index[3]]? imgList[index[3]]?.name:null}
            </h2>


          
          </Link>
        </div>
        <Image
          src={"/icons/BoutonsSlideFleshRight.png"}
          width={30}
          height={18}
          alt="Flesh-Right-Icon"
          className="object-contain w-[30px] h-[18px] cursor-pointer"
          onClick={plus}
        />
      </div>
    </div>
  );
};

export default BoutonsSlides;
